<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">{{__('Users')}}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.first_name }} {{ form.last_name }}
    </h1>
    <trashed-message v-if="contact.deleted_at" class="mb-6" @restore="restore">
      This user has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" id="first_name" :label="__('First Name')"/>
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" id="last_name" :label="__('Last Name')" />
          <!-- <text-input v-model="form.ref_no" :error="form.errors.ref_no" class="pr-6 pb-8 w-full lg:w-1/2" label="Ref. No" /> -->
          <select-input v-if="$page.props.auth.user.owner" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Customer">
            <option :value="null" />
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Email')" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" :label="__('Password')" />
          <text-input v-model="form.business_name" :error="form.errors.business_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Bakery Name')" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Phone')" />
          <!-- <select-input v-model="form.lang" :error="form.errors.lang" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Language')">
            <option value="nl" > Dutch </option>
            <option value="en" > English </option>            
            <option value="fr" > French </option>
          </select-input> -->
          <text-input v-model="form.vat_no" :error="form.errors.vat_no" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('VAT No')" />
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- Invoice Address -->
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Invoice Address street + Number')" />
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('City')" />
          <!-- <text-input v-model="form.region" :error="form.errors.region" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Province/State')" /> -->
         <select-input v-model="form.country" :error="form.errors.country" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')">
            <option :value="null" > {{__('Select Country')}} </option>
            <option v-for="(countryItem, index) in $page.props.countries" 
                    :key="index" :value="countryItem.iso2"
                    >{{countryItem.name}}</option>
          </select-input>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Postal code')" />
          <!-- <text-input v-model="form.address_ref_no" :error="form.errors.address_ref_no" class="pr-6 pb-8 w-full lg:w-1/2" label="Address Ref. No" /> -->
         
        <!--
           <select-input v-if="$page.props.auth.user.owner || $page.props.auth.user.customer_id > 0" v-model="form.ind_kitchen" :error="form.errors.ind_kitchen" class="pr-6 pb-8 w-full lg:w-1/2" label="Kitchen Type">
              <option :value="0" > {{__('Normal Kitchen')}} </option>
              <option :value="1" > {{__('Independent Kitchen')}} </option>
            </select-input>
          -->
        </div>

         <!-- Shipping address -->
         <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-if="this.contact.shipping_address_id > 0 || !form.sameAsInvoive">
          

              <text-input v-model="form.shipping_address" :error="form.errors.shipping_address" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Shipping Address street + Number')" />
                <text-input v-model="form.shipping_city" :error="form.errors.shipping_city" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('City')" />
                <!-- <text-input v-model="form.shipping_region" :error="form.errors.shipping_region" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Province/State')" /> -->
                <select-input v-model="form.shipping_country" :error="form.errors.shipping_country" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')">
                  <option :value="null" > {{__('Select Country')}} </option>
                  <option v-for="(countryItem, index) in $page.props.countries" :key="index" :value="countryItem.iso2">{{countryItem.name}}</option>
                </select-input>
                <text-input v-model="form.shipping_postal_code" :error="form.errors.shipping_postal_code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Postal code')" />

                  <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <input
                      type="checkbox"
                      name="sameAsInvoive"
                      :value="form.sameAsInvoive"
                      v-model="form.sameAsInvoive"
                      style="margin-right: 10px;"
                    />
                    <label for="sameAsInvoive">{{__('Shipping Address Same As Invoice')}}</label>
                    
                  </div>
          </div>
          <div class="p-12 -mr-6 -mb-8 flex flex-wrap" v-else>

            <input
              type="checkbox"
              name="sameAsInvoive"
              :value="form.sameAsInvoive"
              v-model="form.sameAsInvoive"
              style="margin-right: 10px;"
            />
            <label for="sameAsInvoive">{{__('Shipping Address Same As Invoice')}}</label>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!contact.deleted_at && $page.props.auth.user.owner" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{__('Delete')}} {{__('User')}}</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{__('Update')}} {{__('User')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  created(){
    // console.log(this.contact)
    // console.log(this.organizations[0].id)
    // console.log(this.shipping_address[0].city)
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    contact: Object,
    organizations: Array,
    shipping_address: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        ref_no: this.contact.ref_no,
        organization_id: this.contact.organization_id,
        email: this.contact.email,
        password: null,
        business_name: this.contact.business_name,
        phone: this.contact.phone,
        address: this.contact.address,
        city: this.contact.city,
        region: this.contact.region,
        country: this.contact.country,
        postal_code: this.contact.postal_code,
        address_ref_no: this.contact.address_ref_no,
        lang: 'nl',
        vat_no: this.contact.vat_no,
        ind_kitchen: this.contact.ind_kitchen,
        shipping_address: (this.shipping_address.length>0?this.shipping_address[0].address:null),
        shipping_city: (this.shipping_address.length>0?this.shipping_address[0].city:null),
        shipping_region: (this.shipping_address.length>0?this.shipping_address[0].region:null),
        shipping_country: (this.shipping_address.length>0?this.shipping_address[0].country:null),
        shipping_postal_code: (this.shipping_address.length>0?this.shipping_address[0].postal_code:null),
        sameAsInvoive: (this.contact.shipping_address_id>0?false:true)
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('contacts.update', this.contact.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this User?')) {
        this.$inertia.delete(this.route('contacts.destroy', this.contact.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this User?')) {
        this.$inertia.put(this.route('contacts.restore', this.contact.id))
      }
    },
  },
}
</script>
<style scoped>
.label{
  width: -moz-available;
  margin-bottom: 5px;
}
</style>